import { useState } from "react";
import { useSettings } from "../hooks/useSettings";

const AccountSettings = () => {
    const { currentUser, updateAccount, loading } = useSettings();
    const [inputs, setInputs] = useState({
        username: currentUser?.username || "",
        email: currentUser?.email || "",
    });

    const handleChange = (e) => {
        setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateAccount(inputs);
    };

    return (
        <div className="tab-content">
            <h2>
                Account Details
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>
                        Email
                    </label>

                    <input 
                        type="email" 
                        name="email"
                        value={inputs.email} 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>
                        Username
                    </label>

                    <input 
                        type="text" 
                        name="username"
                        value={inputs.username} 
                        onChange={handleChange} 
                        required 
                    />
                </div>
                
                <button type="submit" disabled={loading}>
                    {loading ? "Saving..." : "Save Changes"}
                </button>
            </form>
        </div>
    );
};
export default AccountSettings;